import React, {Fragment} from 'react';

export function getStatusIconByStatus(status) {
    switch (status) {
        case 1:
        case "1":
        case 'yellow':
            return 'gradient-question-mark';
        case 2:
        case "2":
        case 'green':
            return 'gradient-check';
        default:
            return 'gradient-attention'
    }
}

export function getOverallStatus(sections) {
    const counts = {problems: 0, hints: 0, error: false}
    sections.map((section, i) => {
        if (section.hasOwnProperty('counts', section)) {
            if(false === section.counts) {
                counts.error = true
            } else {
                counts.problems += section.counts.problems
                counts.hints += section.counts.hints
            }
        }
    })

    if (counts.error) return 5; //@todo gray state
    if (counts.problems > 0) return 0;
    if (counts.hints > 0) return 1;

    return 2;
}

const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

export function getUrlParam() {
    let url = new URLSearchParams(window.location.search).get('u');

    if(!url) {
        return null;
    }

    if(base64regex.test(url)) {
        try {
            url = window.atob(url)
        } catch (e) {
            return null;
        }
    }

    url = addHttpIfNeeded(url);

    if (!isValidUrl(url)) {
        return null;
    }

    return url;
}

export function addHttpIfNeeded(url) {
    if(!url) {
        return url;
    }

    if (/^[a-z]+:\/\/.*$/i.test(url)) { // check for any protocol
        return url;
    }

    return `http://${url}`;
}

export function isValidUrl(url) {
    if (typeof url === "undefined") {
        return;
    }

    url = addHttpIfNeeded(url);

    try {
        let urlObject = new URL(url);

        if (!/^https?:$/i.test(urlObject.protocol)) {
            return false;
        }

        const parts = urlObject.hostname.split(".");

        if (parts.length < 2) {
            return false;
        }

        const topLevelDomain = parts[parts.length - 1];

        if (topLevelDomain.length > 1) {
            return true;
        }
    } catch (e) {
    }

    return false;
}

export function stripHttps(url) {
    if (!url) {
        return url;
    }

    return url
        .replace('http://', '')
        .replace('https://', '');
}
